import React from "react";
import { Wifi, RefreshCcw, Loader2 } from "lucide-react";
import { useQzTrayConnection } from "../../../hooks/qztray/useQzTrayConnection";

/**
 * 🧩 ConnectionActionsPanel
 *
 * Panel de acciones rápidas para gestionar la conexión QZ Tray.
 * Incluye botones de Ping y Reconexión (la verificación de versión
 * se maneja ahora desde el card "Versión QZ Tray").
 */
const ConnectionActionsPanel: React.FC = () => {
  const {
    pingConnection,
    reconnectClient,
    isPingLoading,
    isReconnectLoading,
  } = useQzTrayConnection();

  // 🔁 Estado de bloqueo general
  const disabled = isPingLoading || isReconnectLoading;

  return (
    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-5 mt-6 transition-colors">
      <h3 className="font-medium text-black dark:text-white mb-4">
        Acciones de Conexión
      </h3>

      <div className="flex flex-wrap gap-3">
        {/* 🔹 Probar conexión */}
        <button
          onClick={pingConnection}
          disabled={isPingLoading}
          className={`inline-flex items-center gap-2 rounded py-2 px-4 text-sm font-medium text-white shadow-sm transition-all ${
            isPingLoading
              ? "bg-primary/60 cursor-not-allowed"
              : "bg-primary hover:bg-primary/90"
          }`}
        >
          {isPingLoading ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <Wifi className="h-4 w-4" />
          )}
          {isPingLoading ? "Probando..." : "Probar Conexión"}
        </button>

        {/* 🔹 Reconectar */}
        <button
          onClick={reconnectClient}
          disabled={isReconnectLoading}
          className={`inline-flex items-center gap-2 rounded py-2 px-4 text-sm font-medium text-white shadow-sm transition-all ${
            isReconnectLoading
              ? "bg-[#3CA745]/60 cursor-not-allowed"
              : "bg-[#3CA745] hover:bg-[#2E7B35]"
          }`}
        >
          {isReconnectLoading ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <RefreshCcw className="h-4 w-4" />
          )}
          {isReconnectLoading ? "Reconectando..." : "Reconectar"}
        </button>
      </div>
    </div>
  );
};

export default ConnectionActionsPanel;
